import { cn } from '@calendar/lib/utils';

export default function Container({ children, className }: { children: React.ReactNode, className?: string }) {
  return (
    <div className={cn('app--calendar__component--container', className)}>
      {children}
    </div>
  );
}
